// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1TbIt","title":"Images45_title__OCT6s","images":"Images45_images__1mA2t"};